module.exports = __webpack_public_path__ + "static/media/air2.1363afc7.jpg";